import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import DataGrid, {
  Toolbar,
  Item,
  Selection,
  Paging,
  Scrolling,
  LoadPanel,
  Editing,
  Column,
  GroupPanel,
  Sorting,
  SearchPanel,
  Lookup,
  KeyboardNavigation,
  Format,
} from 'devextreme-react/data-grid';
import { DeleteButton, CloneButton, CadastroButton, ImportarButton, updateSummary } from './utilsUI';
import { dataSource, onRowInsertingUpdating } from './utilsAPI';
import { dataGridColumns } from './dataGridColumns';
import CadastroProdutosServicos from '../../../cadastro/ProdutoServico';
import { DropDownOptions } from 'devextreme-react/lookup';
import { useDataCadastro } from '../../../../contexts/DataCadastroContext';
import { Popup } from '../../../../components/Popup/Popup'


import ObterItens from './ObterItens';

export const ProdutosServicos = ({ grupoId, className }) => {
  const { dataCadastro } = useDataCadastro();
  const gridRef = useRef();
  const [popupVisible, setPopupVisible] = useState(false);
  const [importarVisible, setImportarVisible] = useState(false);
  const [localDataSource, setLocalDataSource] = useState([]);

  const loadData = useCallback(async () => {
    try {
      const data = await dataSource(grupoId);
      setLocalDataSource(data);
    } catch (error) {
      console.error("Erro ao carregar dados:", error);
    }
  }, [grupoId]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    if (dataCadastro && gridRef.current) {
      gridRef.current.instance.refresh();
    }
  }, [dataCadastro]);

  const handleEditorPreparing = useCallback((e) => {
    e.editorOptions.dropDownOptions = { width: 400 };
  }, []);

  const handleContentReady = useCallback(() => {
    updateSummary(gridRef, grupoId);
  }, [grupoId]);

  const handleUpdateSummary = useCallback(() => {
    updateSummary(gridRef, grupoId);
  }, [grupoId]);

  const columns = useMemo(
    () => (dataCadastro ? dataGridColumns(dataCadastro) : []),
    [dataCadastro]
  );

  if (!dataCadastro) {
    return <div>Carregando dados...</div>;
  }

  return (
    <div className={`row mx-0 ${className}`}>

      <Popup
        visible={popupVisible}
        setVisible={setPopupVisible}
        // onClose={''}
        // onClickOk={loadData()}
        content={<CadastroProdutosServicos hidePageContainer={true} height={'47vh'} />}
      />


      <DataGrid
        ref={gridRef}
        id={`gridProdutoServico${grupoId}`}
        dataSource={localDataSource}
        showColumnLines
        showRowLines
        showBorders
        rowAlternationEnabled={false}
        allowColumnReordering={false}
        allowColumnResizing
        onEditorPreparing={handleEditorPreparing}
        hoverStateEnabled
        repaintChangesOnly={false}
        activeStateEnabled
        onSaved={handleUpdateSummary}
        onCellHoverChanged={handleUpdateSummary}
        onContentReady={handleContentReady}

        onRowInserting={(e) => onRowInsertingUpdating(e, dataCadastro)}
        onRowUpdating={(e) => onRowInsertingUpdating(e, dataCadastro)}

     



      >
        <Toolbar>
          <Item location="before" text="Produtos/Serviços" />
          <Item location="after" name="addRowButton" options={{ stylingMode: "contained" }} />
          <Item location="after" name="saveButton" options={{ stylingMode: "contained" }} />
          <Item location="after">
            <div className="vr mx-2" />
          </Item>
          <Item location="after">
            <CloneButton gridRef={gridRef} dataSource={localDataSource} grupoId={grupoId} />
          </Item>
          <Item location="after">
            <DeleteButton gridRef={gridRef} dataSource={localDataSource} grupoId={grupoId} />
          </Item>
          <Item location="after">
            <ImportarButton setImportarVisible={setImportarVisible} />
          </Item>
          <Item location="after" name="revertButton" options={{ stylingMode: "contained" }} />
          <Item location="after">
            <CadastroButton setPopupVisible={setPopupVisible} />
          </Item>

        </Toolbar>

        <Selection mode="multiple" showCheckBoxesMode="always" />
        <Editing
          mode="batch"
          allowUpdating
          allowAdding
          allowDeleting={false}
          selectTextOnEditStart={false}
          startEditAction="click"
          useIcons
          newRowPosition="last"
        />

        <KeyboardNavigation editOnKeyPress />
        <Paging enabled={false} />
        <Scrolling mode="standard" useNative />
        <LoadPanel enabled />
        <GroupPanel visible={false} />
        <SearchPanel visible={false} />
        <Sorting mode="none" />

        {columns.map((item) => (
          <Column
            key={item.dataField || item.caption}
            caption={item.caption}
            dataField={item.dataField}
            dataType={item.dataType}
            width={item.width}
            minWidth={item.minWidth}
            allowEditing={item.allowEditing}
            alignment={item.alignment}
            fixed={item.fixed}
            name={item.name}
            visible={item.visible}
            calculateCellValue={item.calculateCellValue}
            fixedPosition={item.fixedPosition}
            calculateDisplayValue={item.calculateDisplayValue}
            allowClearing={item.allowClearing}
          >
            {item.lookup && (
              <Lookup
                searchEnabled={false}
                dataSource={{
                  store: {
                    data: item.dataSource,
                    type: 'array',
                    key: 'id',
                  },
                  paginate: true,
                  pageSize: 250,
                }}
                valueExpr={item.valueExpr}
                displayExpr={item.displayExpr}
              >
                <DropDownOptions hideOnOutsideClick showTitle />
              </Lookup>
            )}
            {item.formatType && (
              <Format type={item.formatType} precision={item.formatPrecision} />
            )}
          </Column>
        ))}
        <Column type="selection" width={55} fixed fixedPosition="right" />
      </DataGrid>

      <div className="d-flex fw-bold rounded-bottom mx-0 px-0 pt-2">
        <div className="px-2">
          Items: <span id={`produto-servico-total-item-label${grupoId}`} />
        </div>
        <div className="px-2 text-primary">
          Total: <span id={`produto-servico-total-valor-label${grupoId}`}>0,00</span>
        </div>
        <input id={`produto-servico-total-item-value${grupoId}`} className="invisible" readOnly value={0} />
        <input id={`produto-servico-total-valor-value${grupoId}`} className="invisible" readOnly value={0} />
      </div>

      {/* Modal Bootstrap para Importar */}
      <ObterItens

        importarVisible={importarVisible}
        setImportarVisible={setImportarVisible}

        gridRef={gridRef}
        dataSource={localDataSource}
        grupoId={grupoId}
        dataUnidadeMedida={dataCadastro?.unidade_de_medida ?? []}

      />
    </div>
  );
};
